var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instagram-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram-logo",
    fill: "#6C757D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4007059,0 L5.48870588,0 C2.46223529,0 0,2.46235294 0,5.48882353 L0,14.4008235 C0,17.4274118 2.46223529,19.8896471 5.48870588,19.8896471 L14.4007059,19.8896471 C17.4274118,19.8896471 19.8896471,17.4272941 19.8896471,14.4008235 L19.8896471,5.48882353 C19.8897647,2.46235294 17.4274118,0 14.4007059,0 Z M18.1250588,14.4008235 C18.1250588,16.4543529 16.4543529,18.1249412 14.4008235,18.1249412 L5.48870588,18.1249412 C3.43529412,18.1250588 1.76470588,16.4543529 1.76470588,14.4008235 L1.76470588,5.48882353 C1.76470588,3.43541176 3.43529412,1.76470588 5.48870588,1.76470588 L14.4007059,1.76470588 C16.4542353,1.76470588 18.1249412,3.43541176 18.1249412,5.48882353 L18.1249412,14.4008235 L18.1250588,14.4008235 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94482353,4.82 C7.11882353,4.82 4.81976471,7.11905882 4.81976471,9.94505882 C4.81976471,12.7709412 7.11882353,15.0698824 9.94482353,15.0698824 C12.7708235,15.0698824 15.0698824,12.7709412 15.0698824,9.94505882 C15.0698824,7.11905882 12.7708235,4.82 9.94482353,4.82 Z M9.94482353,13.3050588 C8.092,13.3050588 6.58447059,11.7977647 6.58447059,9.94494118 C6.58447059,8.092 8.09188235,6.58458824 9.94482353,6.58458824 C11.7977647,6.58458824 13.3051765,8.092 13.3051765,9.94494118 C13.3051765,11.7977647 11.7976471,13.3050588 9.94482353,13.3050588 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2848235,3.32364706 C14.9448235,3.32364706 14.6108235,3.46129412 14.3707059,3.70247059 C14.1294118,3.94247059 13.9907059,4.27658824 13.9907059,4.61776471 C13.9907059,4.95788235 14.1295294,5.29188235 14.3707059,5.53305882 C14.6107059,5.77305882 14.9448235,5.91188235 15.2848235,5.91188235 C15.626,5.91188235 15.9589412,5.77305882 16.2001176,5.53305882 C16.4412941,5.29188235 16.5789412,4.95776471 16.5789412,4.61776471 C16.5789412,4.27658824 16.4412941,3.94247059 16.2001176,3.70247059 C15.9601176,3.46129412 15.626,3.32364706 15.2848235,3.32364706 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.c3947659c74a540f7b64aff71d856563.svg";
export { ForwardRef as ReactComponent };